import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  buttonContainer: {
    display: 'flex',
    marginBottom: theme.spacing(2),
    justifyContent: 'flex-end',
  },
  title: {
    ...theme.typography.h6,
    marginRight: theme.spacing(0.5),
  },
  icon: {
    height: theme.spacing(1.54),
    width: 'auto',
    marginLeft: theme.spacing(0.625),
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'baseline',
  },
}));
